module.exports = __webpack_public_path__ + "img/ic_gongyinglian.49d6ee54.svg";